export default "__VITE_ASSET__BqT$vpmW__"